const designTimers = new Map();

export function downstreamScriptIds(rootId, edges, nodes) {
  const typeById = {};
  (nodes || []).forEach((n) => {
    typeById[n.id] = n.data?.type;
  });
  const adj = {};
  (edges || []).forEach((e) => {
    if (!e?.source || !e?.target) return;
    if (!adj[e.source]) adj[e.source] = [];
    adj[e.source].push(e.target);
  });
  const seen = new Set([rootId]);
  const q = [rootId];
  const scripts = [];
  while (q.length) {
    const id = q.shift();
    for (const t of adj[id] || []) {
      if (seen.has(t)) continue;
      seen.add(t);
      q.push(t);
      if (typeById[t] === 'workflow/script') scripts.push(t);
    }
  }
  return scripts;
}

export function designScriptResult(data, { trigger = 'manual' } = {}) {
  const language = data?.parameter_data?.language || 'python';
  const code = String(data?.parameter_data?.code || '').trim();
  const at = new Date().toISOString();
  const stdout = code
    ? `[design] ${language}\n${code}`
    : `[design] ${language} (no code)`;
  const preview = stdout.length > 200 ? `${stdout.slice(0, 199)}…` : stdout;
  const producedBy = data?.id || 'script';
  const result = {
    kind: 'agent.handle.v1',
    scheme: 'inline',
    media_type: 'text/plain',
    sha256: 'design',
    bytes: stdout.length,
    preview,
    truncated: false,
    text: stdout,
    produced_by: producedBy,
    produced_at: at,
  };
  return {
    output_data: {
      ...(data?.output_data || {}),
      result,
      last_run: {
        status: 'ok',
        at,
        exit: 0,
        stdout_preview: preview,
        trigger,
      },
    },
  };
}

export function designActivatePatch(data, active) {
  return {
    parameter_data: {
      ...(data?.parameter_data || {}),
      active: Boolean(active),
    },
  };
}

export function startDesignTimer(id, onTick) {
  stopDesignTimer(id);
  if (typeof onTick === 'function') {
    onTick();
    const handle = setInterval(onTick, 10000);
    designTimers.set(id, handle);
  }
}

export function stopDesignTimer(id) {
  const handle = designTimers.get(id);
  if (handle) clearInterval(handle);
  designTimers.delete(id);
}

export function formatLastRunLabel(lastRun) {
  if (!lastRun || !lastRun.at) return '';
  const mark = lastRun.status === 'ok' ? '✓' : lastRun.status === 'running' ? '…' : '✗';
  const t = new Date(lastRun.at);
  if (Number.isNaN(t.getTime())) return mark;
  const hh = String(t.getHours()).padStart(2, '0');
  const mm = String(t.getMinutes()).padStart(2, '0');
  const ss = String(t.getSeconds()).padStart(2, '0');
  return `${mark} ${hh}:${mm}:${ss}`;
}
